import debug from 'debug';
import { MSN_EVENTS_NAMES_MAPPING } from './const';

const log = debug('beacon:msnTarget');

const coreToApi = (event) => ({
  ...event,
  eventName: MSN_EVENTS_NAMES_MAPPING[event.eventName],
});

const msnTarget = (events) =>
  events.forEach((evts) => {
    const evtsArr = Array.isArray(evts) ? evts : [evts];
    evtsArr.forEach((evt) => {
      if (!evt || !evt.eventName) {
        log('Dropping event: Needs `eventName`.', evt);
        return;
      }

      const data = coreToApi(evt);
      if (window !== window.parent) {
        // we are on an IFrame
        window.parent.postMessage(JSON.stringify(data), '*');
      }
    });
  });

export { msnTarget };
